import React from 'react';

function Home() {
    return (
        <div>
            <h1>Welcome to HOLO</h1>
            <p>This is the home page.</p>
            <a href="https://www.flaticon.com/kr/free-icons/" title="송장 아이콘">송장 아이콘 제작자: Freepik - Flaticon</a>
        </div>
    );
}

export default Home;
